import { IntlMessageFormat } from 'intl-messageformat';
import { catalogs, DEFAULT_LOCALE, LOCALES } from './catalog.js';
const formatterCache = new Map();
function formatterFor(locale, key, message) {
    const cacheKey = `${locale}::${key}`;
    let f = formatterCache.get(cacheKey);
    if (!f) {
        f = new IntlMessageFormat(message, locale);
        formatterCache.set(cacheKey, f);
    }
    return f;
}
function cleanParams(params) {
    const out = {};
    if (!params)
        return out;
    for (const [k, v] of Object.entries(params)) {
        if (v === null || v === undefined)
            continue;
        out[k] = v;
    }
    return out;
}
/**
 * Perender untuk satu bahasa.
 *
 * `onMissing` dipanggil ketika sebuah kunci tidak ada. Token desain menyatakannya:
 * "A missing key falls back to the English string and is logged — never a blank,
 * never a raw key." Di konsol, pemanggilnya menulis ke konsol pengembang; di
 * server ia tidak dipakai sama sekali, karena server tidak merender kalimat.
 */
export function createTranslator(locale, onMissing) {
    const primary = catalogs[locale] ?? catalogs[DEFAULT_LOCALE];
    const fallback = catalogs[DEFAULT_LOCALE];
    return {
        locale,
        has(key) {
            return Object.prototype.hasOwnProperty.call(primary, key);
        },
        t(key, params) {
            let message = primary[key];
            let usedLocale = locale;
            if (message === undefined) {
                onMissing?.(key, locale);
                message = fallback[key];
                usedLocale = DEFAULT_LOCALE;
            }
            if (message === undefined)
                return key;
            try {
                const rendered = formatterFor(usedLocale, key, message).format(cleanParams(params));
                return Array.isArray(rendered) ? rendered.join('') : String(rendered);
            }
            catch {
                // Parameter yang kurang tidak boleh menjatuhkan layar; kembalikan pesan mentah.
                return message;
            }
        },
    };
}
/**
 * Merender `Problem` dari API menjadi kalimat pengguna.
 * `detail_en` SENGAJA diabaikan: ia untuk log dan dukungan, bukan untuk layar.
 */
export function renderProblem(translator, problem) {
    return translator.t(`error.${problem.code}`, (problem.params ?? {}));
}
/** Kunci yang ada di `reference` tetapi tidak di `subject`. */
export function missingKeys(reference, subject) {
    return Object.keys(reference)
        .filter((k) => !Object.prototype.hasOwnProperty.call(subject, k))
        .sort();
}
/** Kunci yang ada di `subject` tetapi tidak di `reference`. */
export function extraKeys(reference, subject) {
    return missingKeys(subject, reference);
}
export { LOCALES };
//# sourceMappingURL=translator.js.map